import { createServerStateStore } from "./serverState";

export type SmsChannel = "auth" | "operational" | "marketing";
export type SmsLogStatus = "queued" | "sent" | "failed" | "disabled";

export interface SmsLogRecord {
  id: string;
  phone: string;
  customerId?: number;
  channel: SmsChannel;
  eventType: string;
  message: string;
  status: SmsLogStatus;
  providerResponse?: string;
  createdAt: string;
  sentAt?: string;
}

const store = createServerStateStore<SmsLogRecord[]>("sms_logs", []);

export function getSmsLogs() {
  return store.getState();
}

export async function rehydrateSmsLogs() {
  return store.rehydrate();
}

export function subscribeSmsLogs(listener: () => void) {
  return store.subscribe(listener);
}

export async function clearSmsLogs() {
  return store.reset();
}

export async function addSmsLog(
  payload: Omit<SmsLogRecord, "id" | "createdAt">
) {
  const nextItem: SmsLogRecord = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    createdAt: new Date().toISOString(),
    ...payload,
  };

  await store.setState((prev) => [nextItem, ...prev].slice(0, 500));
  return nextItem;
}